const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fire-and-forget analytics: pushes to GA/dataLayer if present and to our backend.
export const trackEvent = (type, meta = {}) => {
  try {
    if (typeof window !== "undefined") {
      if (window.gtag) window.gtag("event", type, meta);
      if (window.dataLayer) window.dataLayer.push({ event: type, ...meta });
    }
  } catch (e) { /* no-op */ }
  try {
    fetch(`${API}/analytics/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, meta }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) { /* no-op */ }
};
